import React from "react";
import { Typography } from "@mui/material";
import PreviewIcon from '@mui/icons-material/Preview';

import Grid from '@mui/material/Grid2';
import ManualReviewQueue from "./ManualReviewQueue";

function ManualReview() {
  return (
    <Grid container spacing={3} sx={{ padding: "20px" }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ color: "#00f5d4", marginBottom: "10px" }}>
          <PreviewIcon /> Manual Review
        </Typography>
        <ManualReviewQueue />
      </Grid>
    </Grid>
  );
}

export default ManualReview;
